import { ConfigRepository } from '../repositories/ConfigRepository';
import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/ProductService';
import { ProdcatApiSdk } from '../../api/ProdcatApiSdk';
import { Config } from '../domain/entities/Config';
import { ProductRepository } from '~repositories/ProductRepository';
import { InventoryRepository } from '~repositories/InventoryRepository';

export class ProductServiceStartedUseCase {
    private configRepository: ConfigRepository;
    private prodcatApiSdk: ProdcatApiSdk;
    private productRepository: ProductRepository;
    private inventoryRepository: InventoryRepository;
    private configService: Config;
    private configs: string[];

    constructor(configs: string[]) {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.prodcatApiSdk = diContainer.get(serviceNames.prodcatApiSdk);
        this.configService = diContainer.get(serviceNames.config);
        this.productRepository = diContainer.get(serviceNames.productRepository);
        this.inventoryRepository = diContainer.get(serviceNames.inventoryRepository);
        this.configs = configs;
    }

    public execute = async () => {
        await this.configRepository.getConfigs(this.configs);

        // todo: get to the point when we can remove this
        this.prodcatApiSdk.setQueryFragments(diContainer.get(serviceNames.queryFragments));

        const {
            viewableInventoryStatuses,
            backorder,
            inventoryStatusSorting,
            prodcatInventory,
            features,
            graphqlExtensionVersion
        } = this.configService.config;
        const repositoryConfig = {
            viewableInventoryStatuses,
            backorderEnabled: backorder && backorder.enabled,
            inventoryStatusSorting
        };

        this.prodcatApiSdk.setConfigs({
            graphqlExtensionVersion: graphqlExtensionVersion || 'v1',
            features
        });
        this.productRepository.setConfigs(repositoryConfig);
        this.inventoryRepository.setConfigs({ prodcatInventory });
    };
}
